export default "__VITE_ASSET__ee9ef75b__"